import { rebottle } from "../elements";
import type { BottleType, CanvasData } from "../schema";
import { INK, centred, doc, hairline, imageSlot } from "./kit";
import type { LabelTemplate } from "./types";

// Seal: the estate's name set as a wordmark at the top, the visitor's logo
// mid-label like a seal between two bronze rules, the year and place below.
function wine(): CanvasData {
  const b = "wine";
  const slot = { x: 32, y: 40, width: 26, height: 26 };
  const mid = slot.y + slot.height / 2;
  return doc(b, INK["warm-white"], [
    imageSlot(slot, "Add your logo"),
    centred(b, { text: "YOUR ESTATE", font: "cinzel", size: 6, color: INK.charcoal, baseline: 18, tracking: 0.1 }),
    centred(b, { text: "Grand Reserve", font: "cormorant", italic: true, size: 3.2, color: INK.burgundy, baseline: 26, tracking: 0.03 }),
    hairline(INK.bronze, 45, 31, 30),
    hairline(INK.bronze, 17, mid, 18),
    hairline(INK.bronze, 73, mid, 18),
    centred(b, { text: "2026", font: "cormorant", size: 3, color: INK.charcoal, baseline: 78, tracking: 0.08 }),
    centred(b, { text: "Stellenbosch · South Africa", font: "montserrat", size: 1.8, color: INK.charcoal, baseline: 88, tracking: 0.2 }),
  ]);
}

export const logoSeal: LabelTemplate = {
  key: "logo-seal",
  name: "Seal",
  occasion: "classic",
  style: "Wordmark above, logo as a seal",
  description: "Your estate's name above and your logo set like a seal between two rules.",
  hasImageSlot: true,
  slot: "logo",
  build: (bottle: BottleType) => (bottle === "wine" ? wine() : rebottle(wine(), bottle)),
};
